import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../store/authStore";
import api from "../services/api";

export function useAuth() {
  const navigate = useNavigate();
  const { user, token, isAuthenticated, setAuth, logout } = useAuthStore();

  const login = async (email: string, senha: string) => {
    try {
      const response = await api.post("/auth/login", { email, senha });
      const { user, token, refreshToken } = response.data.data;
      setAuth(user, token, refreshToken);
      navigate(user.perfil === "cliente" ? "/cliente" : "/");
      return { success: true };
    } catch (error: any) {
      return {
        success: false,
        error: error.response?.data?.error?.message || "Erro ao fazer login",
      };
    }
  };

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return {
    user,
    token,
    isAuthenticated,
    login,
    logout: handleLogout,
    can: useAuthStore.getState().can,
  };
}
